<template>
  <div
    :class="[
      'card',
      margin ? marginClass : 'mb-0',
      shadowClass ? 'shadow-card' : '',
    ]"
  >
    <div
      :class="[
        'card-header border-0',
        showHeader === false ? 'card-display' : '',
        padding ? 'pt-5' : 'pt-8',
      ]"
    >
      <div>
        <h2 :class="[fontStyle === true ? 'heading-style' : 'heading']">
          {{ title }}
        </h2>
        <p class="subheading" v-if="description">
          {{ description }}
        </p>
      </div>
      <div
        class="card-toolbar"
        data-kt-buttons="true"
        v-if="showToolbarButtons"
      >
        <slot name="toolbar">
          <a
            class="
              btn btn-sm btn-color-muted btn-active btn-active-primary
              px-4
              me-1
            "
            :class="[{ active: days === 7 }]"
            @click="changeDaysValue(7)"
            >Last 7 days</a
          >

          <a
            class="
              btn btn-sm btn-color-muted btn-active btn-active-primary
              px-4
              me-1
            "
            :class="[{ active: days === 14 }]"
            @click="changeDaysValue(14)"
            >Last 14 days</a
          >

          <a
            class="
              btn btn-sm btn-color-muted btn-active btn-active-primary
              px-4
            "
            @click="changeDaysValue(28)"
            :class="[{ active: days === 28 }]"
            >Last 28 days</a
          >

          <a
            class="
              btn btn-sm btn-color-muted btn-active btn-active-primary
              px-4
            "
            :class="[{ active: days === 365 }]"
            @click="changeDaysValue(365)"
            >Last 12 Months</a
          ></slot
        >
      </div>
    </div>
    <div
      :class="[
        'card-body',
        padding ? 'pt-9' : 'pt-0 pb-4',
        paddingLeft ? 'pe-1 ps-1' : '',
      ]"
    >
      <slot name="body" :days="days"></slot>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "CardToolbar",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    showToolbarButtons: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    fontStyle: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    paddingLeft: {
      type: Boolean,
      default: false,
    },
    shadowClass: {
      type: Boolean,
      default: false,
    },
    marginClass: {
      type: String,
      default: "mb-5 mb-xl-10",
    },
  },
  setup(props, context) {
    const days = ref(365);

    const changeDaysValue = (day) => {
      days.value = day;
      context.emit("daysChanged", days.value);
    };

    return { days, changeDaysValue };
  },
};
</script>

<style lang="scss" scoped>
.card-display {
  display: none;
}

.heading-style {
  font-size: 14px;
  font-weight: 500;
  color: #33647f;
}
</style>
